module.exports = __webpack_public_path__ + "media/images/common/credit_cards/discover-cf06b6f781320ad8b67e0ad7da9301d2.svg";